/**
 * cookie里的信息
 */

const headerList = (cookielist)=> {

    let Authorization = '',
        city_id = 0,
        app_key = 'hunbasha_wap', 
        jid='', 
        app_channel='',
        app_version='', 
        pageId='',
        device_id='';

    if(cookielist) {
        let cookieArr = cookielist.split(';');
        for (let i in cookieArr) {
            let cookie = cookieArr[i].replace(/(^\s*)|(\s*$)/g,"")
            let index = cookie.indexOf('=');
            let name = cookie.substr(0,index);
            let value = decodeURIComponent(cookie.substr(index+1));
            switch (name) {
                case 'Authorization':
                    if(value){
                        if(/^dmp/.test(value)){
                            Authorization = value
                        }else{
                            Authorization = 'dmp ' + value
                        }  
                    }      
                    break;
                case 'jhu':
                    if(!Authorization && value){
                        if(/^dmp/.test(value)){
                            Authorization = value
                        }else{
                            Authorization = 'dmp ' + value
                        }    
                    }         
                    break;
                case 'city-id':
                    city_id = value
                    break;
                case 'app-key':
                    app_key = value
                    break;
                case 'jid':
                    jid = value
                    break;
                case 'clientId':
                    jid = value
                    break;
                case 'client-id':
                    jid = value
                    break;
                case 'app-channel':
                    app_channel = value
                    break;
                case 'app-version':
                    app_version = value
                    break;
                case 'page-id':
                    pageId = value
                    break;
                case 'deviceId':
                    device_id = value
                    break;
                case 'device-id':
                    device_id = value
                    break;                
            }
        }
    }

    return {
        Authorization:Authorization,
        city_id:city_id,
        app_key:app_key,
        jid:jid,
        app_version:app_version,
        app_channel:app_channel,
        device_id:device_id,
        pageId:pageId
    };
}

export default headerList


// WEBPACK FOOTER //
// ./src/plugins/headers.js